/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'swapclickable': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M11.978 9.269a.718.718 0 0 1-.714.714H2.48l.784.785a.741.741 0 0 1 .112.91.704.704 0 0 1-1.092.113L.182 9.689a.584.584 0 0 1 0-.84L2.27 6.76a.713.713 0 0 1 1.092.112c.182.28.126.673-.112.91l-.784.785h8.798a.689.689 0 0 1 .714.701zm-.168-6.977L9.723.205A.713.713 0 0 0 8.63.317c-.182.28-.126.672.112.91l.785.785H.714A.718.718 0 0 0 0 2.726c0 .393.322.715.714.715h8.799l-.785.784a.741.741 0 0 0-.112.911.704.704 0 0 0 1.093.112l2.087-2.087a.605.605 0 0 0 .014-.869z" _fill="#3E739B" fill-rule="nonzero"/>'
  }
})
